export const IconEditPencil: {
  name: 'icon_edit_pencil-c8ca416ec1d2'
} = {
  name: 'icon_edit_pencil-c8ca416ec1d2'
}
